import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const DEFAULT_COLORS = { positive: '#22c55e', neutral: '#6b7280', negative: '#ef4444' };
const DEFAULT_LABELS = { positive: 'Positive', neutral: 'Neutral', negative: 'Negative' };

const SentimentPieChart = ({
  positive = 0,
  neutral = 0,
  negative = 0,
  labels = DEFAULT_LABELS,
  colors = DEFAULT_COLORS,
  title = 'Distribution',
}) => {
  const data = [
    { name: labels.positive, value: positive, color: colors.positive },
    { name: labels.neutral, value: neutral, color: colors.neutral },
    { name: labels.negative, value: negative, color: colors.negative },
  ].filter(d => d.value > 0);

  const total = positive + neutral + negative;
  if (total === 0) {
    return (
      <div className="card p-6 flex items-center justify-center h-full">
        <p className="text-sm text-gray-400">No data available</p>
      </div>
    );
  }

  return (
    <div className="card p-5 h-full">
      <h3 className="text-sm font-semibold text-gray-700 mb-2">{title}</h3>
      <div className="flex items-center">
        {/* Donut chart */}
        <div className="w-3/5">
          <ResponsiveContainer width="100%" height={180}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={48}
                outerRadius={72}
                paddingAngle={2}
                dataKey="value"
              >
                {data.map((entry, i) => (
                  <Cell key={i} fill={entry.color} />
                ))}
              </Pie>
              {/* Center total label */}
              <text x="50%" y="45%" textAnchor="middle" dominantBaseline="central" fill="#374151" fontSize="22" fontWeight="bold">
                {total}
              </text>
              <text x="50%" y="60%" textAnchor="middle" dominantBaseline="central" fill="#9ca3af" fontSize="11">
                total
              </text>
              <Tooltip formatter={(value) => [value, 'Count']} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        {/* Side legend */}
        <div className="w-2/5 space-y-2 pl-2">
          {[
            { key: 'positive', value: positive },
            { key: 'neutral', value: neutral },
            { key: 'negative', value: negative },
          ].filter(d => d.value > 0).map(item => (
            <div key={item.key} className="flex items-center space-x-2">
              <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: colors[item.key] }} />
              <div className="min-w-0">
                <p className="text-xs text-gray-500">{labels[item.key]}</p>
                <p className="text-sm font-semibold text-gray-800">
                  {item.value}
                  <span className="text-xs font-normal text-gray-400 ml-1">
                    ({Math.round((item.value / total) * 100)}%)
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(SentimentPieChart);
